<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-14 16:30:54
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-26 14:20:02
-->
<template>
	<!-- 新增地址 -->
	<div class="addAdressDraw">
		<el-drawer :title="title" :visible.sync="visible" :append-to-body="true" :wrapperClosable="false" @closed="handleClose">
			<div class="mt-24 ml-24 mr-24">
				<el-form :model="applyFrom" ref="applyFrom" :rules="applyRuels">
					<div class="label flex-row-align-center flex-just-end">
						<p @click="autoDiscern" class="auto yx-color-primary cursor-pointer">
							<i class="el-icon-edit"></i>
							<span class="ml-6">智能识别地址</span>
						</p>
					</div>
					<el-form-item label="所在区域：" :label-width="formLabelWidth" prop="area">
						<!--v-if每次都重新挂在该组件-->
						<el-col :span="24">
							<el-cascader v-if="visible" @change="selecteFun" :options="AreaTree" width="100%" clearable v-model="selectedOptions"></el-cascader>
						</el-col>
					</el-form-item>
					<el-form-item label="详细地址：" :label-width="formLabelWidth" prop="delivery_addr">
						<el-input
							v-model="applyFrom['delivery_addr']"
							autocomplete="off"
							type="textarea"
							maxlength="100"
							minlength="0"
							show-word-limit
							placeholder="请输入详细地址"
						></el-input>
					</el-form-item>
					<el-form-item label="收件人：" :label-width="formLabelWidth" prop="delivery_name">
						<el-input v-model="applyFrom['delivery_name']" autocomplete="off" placeholder="请输入收件人"></el-input>
					</el-form-item>
					<el-form-item label="手机号：" :label-width="formLabelWidth" prop="delivery_mobile">
						<el-input v-model="applyFrom['delivery_mobile']" autocomplete="off" placeholder="请输入手机号"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="bott">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit" :loading="btnLoading">确认</el-button>
			</div>
		</el-drawer>
		<auto-address @returnValue="returnValue" ref="autoAddress"></auto-address>
	</div>
</template>

<script>
import { anchorDefaultSite } from '@/api/cooperationProgress';
import { getInstitutionAnchorSite, institutionDeliveryInfo } from '@/api/secondColonelManage';
import { validateTel } from '@/utils/validate';
import { updDeliveryInfo } from '@/api/talentCRM';
import area from '@/utils/area/index';
import debounce from 'lodash/debounce';
export default {
	name: 'addAdressDraw',
	data() {
		//字符长度限制
		return {
			title: '新增地址',
			// 杭州市临安区万马樱花公馆2幢1单元902倪国晓18667181848
			visible: false,
			tzId: '',
			drId: '',
			role: '',
			btnLoading: false,
			applyFrom: {
				area: '',
				delivery_addr: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				code: '',
				contact_id: '',
			},
			applyRuels: {
				sku: [{ required: true, message: ' ', trigger: 'blur' }],
				area: [{ required: true, message: '请选择区域', trigger: 'blur' }],
				delivery_addr: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
				delivery_name: [{ required: true, message: '请输入收件人', trigger: 'blur' }],
				delivery_mobile: [{ required: true, validator: validateTel, trigger: 'blur' }],
			},
			AreaTree: area.AreaTree,
			CodeToText: area.CodeToText,
			TextToCode: area.TextToCode,
			selectedOptions: [],
			formLabelWidth: '100px',
		};
	},

	props: {},
	components: {
		autoAddress: () => import('@/views/common/autoAddress'),
	},

	mounted() {},
	computed: {},
	methods: {
		show({ tzId, drId, role, v, delivery_id, addressInfo }) {
			this.tzId = tzId;
			this.role = role;
			this.delivery_id = delivery_id;
			this.addressInfo = addressInfo;
			this.applyFrom.anchor_id = drId;
			if (role == 'isDr') {
				this.applyFrom.contact_id = tzId;
			} else {
				this.applyFrom.team_institution_id = tzId;
			}
			if (v == 'edit') {
				this.title = '编辑地址';
				this.initApplyFun(tzId);
			} else {
				this.title = '新增地址';
			}
			this.visible = true;
			this.v = v;
		},
		async initApplyFun(tzId) {
			this.tzId = tzId;
			this.applyFrom.cooperate_id = tzId;
			this.applyFrom.delivery_id = this.delivery_id || 0;
			let adressArr = [];
			let params = {
				team_institution_id: this.tzId || '',
				anchor_id: this.applyFrom.anchor_id || '',
			};
			let res = {};
			if (!this.addressInfo) {
				res = this.role == 'isDr' ? await anchorDefaultSite({ contact_id: tzId }) : await getInstitutionAnchorSite(params);
			} else {
				res = {
					code: 0,
					data: this.addressInfo,
				};
			}
			const { code, data } = res;
			if (code == 0) {
				adressArr = [data.province, data.city, data.area];
				let [province, city] = this.TextToCode(adressArr);
				this.selectedOptions = [province, city, data.code];
				this.$set(this.applyFrom, 'province', data.province ? data.province : '');
				this.$set(this.applyFrom, 'city', data.city ? data.city : '');
				this.$set(this.applyFrom, 'area', data.area ? data.area : '');
				this.$set(this.applyFrom, 'delivery_addr', data.delivery_addr ? data.delivery_addr : '');
				this.$set(this.applyFrom, 'delivery_name', data.delivery_name ? data.delivery_name : '');
				this.$set(this.applyFrom, 'delivery_mobile', data.delivery_mobile ? data.delivery_mobile : '');
				this.$set(this.applyFrom, 'code', data.code ? data.code : '');

				this.role == 'isDr' && this.$set(this.applyFrom, 'delivery_id', data.delivery_id ? data.delivery_id : '');
			}
		},
		handleClose() {
			Object.assign(this.$data, this.$options.data());
			this.$nextTick(() => {
				this.$refs.applyFrom.clearValidate();
			});
		},

		//选择所选区域地址
		selecteFun(e) {
			let code = e[2];
			let [province, city, area] = this.CodeToText(this.selectedOptions);
			this.applyFrom.province = province;
			this.applyFrom.city = city;
			this.applyFrom.area = area;
			this.applyFrom.code = code;
		},
		//打开地址智能识别
		autoDiscern() {
			this.$refs.autoAddress.show();
		},
		// 接受地址返回值
		returnValue(e) {
			for (let key in e) {
				this.applyFrom[key] = e[key];
			}
			const localCodes = this.TextToCode([e.province, e.city, e.area]);
			let [province, city, area] = this.CodeToText(['', '', e.code]);
			if (!area) {
				this.applyFrom['delivery_addr'] = e.province + e.city + e.area + e.delivery_addr;
			}
			this.selectedOptions = [localCodes[0], localCodes[1], e.code];
			this.applyFrom.code = this.selectedOptions[2];
		},

		submit: debounce(function () {
			this.btnLoading = true;
			try {
				this.$refs.applyFrom.validate(async valid => {
					if (valid) {
						let params = {};
						if (this.role !== 'isDr') {
							const {
								team_institution_id: teamInstitutionId,
								delivery_name: deliveryName,
								anchor_id: anchorId,
								delivery_mobile: deliveryMobile,
								province,
								city,
								area,
								delivery_addr: deliveryAddr,
							} = this.applyFrom;
							params = {
								teamInstitutionId,
								deliveryName,
								anchorId: anchorId || 0,
								deliveryMobile,
								province,
								city,
								area,
								deliveryAddr,
								code: this.applyFrom.code,
								delivery_id: this.applyFrom.delivery_id
							};
						}
						const { code, data } = this.role == 'isDr' ? await updDeliveryInfo(this.applyFrom) : await institutionDeliveryInfo(params);
						if (code == 0) {
							this.$message.success('编辑成功');
							this.$emit('refreshList', { ...data, v: this.v });
							this.handleClose();
						}
					}
				});
			} finally {
				this.btnLoading = false;
			}
		}, 300),
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-cascader {
	width: 100%;
}
.label {
	font-size: 14px;
	color: #1d2129;
	font-weight: 700;
	margin-bottom: 16px;
}
.auto {
	font-weight: normal;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
</style>
